/**
 * avatars.ts —— 5 种 AI 风格头像资源映射（第 10 轮 R6）
 *
 * 资源来自设计交付的 Web 切图 `docs/design/round10/avatars/web/{key}.webp`（256px，6–14KB），
 * 已落库到 `src/assets/avatars/`，由 Vite 打包并产出带指纹的静态 URL（生产可缓存）。
 * 文件名严格对应 `StyleKey`，研发按 key 直接映射，无需查表（DESIGN 8.2）。
 */

import type { StyleKey } from '../core/ai';
import tag from '../assets/avatars/tag.webp';
import lag from '../assets/avatars/lag.webp';
import rock from '../assets/avatars/rock.webp';
import station from '../assets/avatars/station.webp';
import maniac from '../assets/avatars/maniac.webp';

/** 风格 key → 头像 URL（构建后为带指纹的静态资源）。 */
export const STYLE_AVATARS: Readonly<Record<StyleKey, string>> = {
  tag,
  lag,
  rock,
  station,
  maniac,
};
